<template>
	<div class="view-service-list-warp">

		<!-- 酒店民宿 	-->
		<div v-show="true" class="menu-components" style="height: 100%;">
			<div class="quancun-list-wrap" style="background-color: #e8e9eb;">
				<van-list v-model="loading" :finished="finished" @load="onLoad" loading-text = "正在加载..." :offset="300">
					<van-cell v-for="item in list" :key="item.id"  @click="displayArticle(item.ID,item.SID)">
						<div>  
<div class="quancun-list-img"  v-lazy:background-image="item.thumbnail">
  <img v-if="item.ico != 0" class="article-ico" :src="'static/img/ico/'+item.ico+'.png'"/>
</div>
							<div class="newbao-list-content">
								<div class="content-title">{{item.LongTitle}}</div>								
								<div class="quancun-list-bottom">
									<span>{{item.categoryName}}</span>
									<span>
										<img class="eye" src="static/img/service/hotel/star.png" v-for="(starItem,starIndex) in item.star" />
									</span>
								</div>
							</div>
						</div>
					</van-cell>
				</van-list>
				<div v-show="listGoneVisible" class="list-gone van-list__loading-text">
                      我可是有底线的！
        </div>
				<div style="height:1.37rem;"></div>
			</div>
		</div>
	
<!-- 文章内容 -->
    <div v-show="true" class="article-components"   v-bind:style="{ transform:articleY}" > 
        <img class="btn-comments" src="static/img/comments/btn-comments.png" @click="handleComment"/>
        <span class="comments-total">{{commentTotal}}</span>
        <van-loading class="conents-loading" color="white" v-if="conentsLoading"/>        
       <iframe @load="iframeLoaded"  :src="articleSrc"  height="100%" width="100%"  frameborder="0" scrolling="yes" border="0" style="position: relative" ></iframe>
    </div>
    <!-- 文章内容 end-->
      
    <!-- 评论 -->
    <div v-show="commentVisible" class="comment-components" v-bind:style="{ transform:commentY}"> 
     <comments ref="articleComments" contents-id="58691"></comments>
    </div>
    <!-- 评论 END-->  
	
	  
	<!-- 底部导航 -->
		<van-tabbar v-model="active" class="bottom-nav" v-bind:style="{ backgroundColor:  activeColor }">
			<van-tabbar-item :to="{path:'/',query:{view:1}}">
				<span>鲜料</span>
				<template slot="icon" slot-scope="props">
					<img :src="props.active ? icon.newsActive : icon.news" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item :to="'/maps'">
				<span>智图</span>
				<template slot="icon" slot-scope="props">
					<img :src="props.active ? icon.mapsActive : icon.maps"  />
				</template>
			</van-tabbar-item> 
			  <van-tabbar-item :to="{path:'/',query:{view:3}}">
				<span>趣玩</span>
				<template slot="icon" slot-scope="props">
					<img :src="props.active ? icon.payActive : icon.pay"/>
				</template>
			</van-tabbar-item>
			<van-tabbar-item  @click="handleNavService">
				<span>服务</span>
				<template slot="icon" slot-scope="props">
					<img :src="props.active ? icon.serviceActive: icon.service"  />
				</template>
			</van-tabbar-item>
		</van-tabbar>

	</div>
</template>

<script>
	import { Tabbar, TabbarItem, Toast, CellGroup } from 'vant';
	import { NavBar, Tab, Tabs, Search, Button, Field, Popup, Tag } from 'vant';
	import qs from 'qs'; 
	import { List, Cell } from 'vant';
	import { Row, Col } from 'vant';
	import { Loading } from 'vant';
  import request from '@/utils/request'
  import moment from 'moment'
   import comments from '@/components/comments.vue';


	export default {
		name: 'List',
		components: {
      'comments':comments,
			'van-tabbar': Tabbar,
			'van-tabbar-item': TabbarItem,
			'van-nav-bar': NavBar,
			'van-tabs': Tabs,
			'van-tab': Tab,
			'van-search': Search,
			'van-popup': Popup,
			'van-field': Field,
			'van-cell-group': CellGroup,
			'van-button': Button,
			'van-list': List,
			'van-cell': Cell,
			'van-tag': Tag,
			'van-col': Col,
			'van-row': Row,
			'van-loading':Loading
		},
		data() {
			return {
				active:3,
				icon: {
					news: 'static/img/tabbar/white/news.png',
					newsActive: 'static/img/tabbar/white/news-active.png',
					maps: 'static/img/tabbar/white/map4.png',
					mapActive: 'static/img/tabbar/white/map-active.png',
					pay: 'static/img/tabbar/white/pay.png',
					payActive: 'static/img/tabbar/white/pay-active.png',
					service: 'static/img/tabbar/white/service.png',
					serviceActive: 'static/img/tabbar/white/service-active.png',
				}, listQuery: {
              pageIndex: 1,
              pageSize: 10,
          },
				activeColor: "#222633",
        newsType:1,
        back:'',
        lastLoadTime:0,
				//鲜料
				newComponentsShow: false,
				titleHeight: '55px',
				navIconHeight: '0',
				newClass: {
					activeHeight: '0',
					articleHeight:'0',
				},
				
        //-评论======
        commentTotal:0,
        commentY:'translateY(-100%)',
        commentVisible:false,
        //-评论 end ===


				/* 文章 */
        articleY:'translateY(-100%)',
        listGoneVisible:false,
				iframeHeight:'0',
				conentsLoading:true,
				/* 新料快报 */
				list: [],
				loading: false,
				finished: false,
				newsBaoClass: {
					newbaoListHeight: '212px',
				},
				articleSrc:'',
			}
		},
		mounted() {
		  this.back = this.$route.query.back;
		  
			let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
			let elementWith = (w * 0.1826);
			if(w >= 750) {
				elementWith = 137;
				w = 750;
			}
			this.titleHeight = elementWith + 'px';
			this.navIconHeight = (elementWith * 0.3764) + 'px';
			this.newsBaoClass.newbaoListHeight = (w * 0.2826) + 'px'; //新料快报列表高度
			let vm = this;
			window.onresize = function temp() {
				let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
				let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
				let elementWith = (w * 0.1826);
				if(w >= 750) {
					elementWith = 137;
					w = 750;
				}
				vm.titleHeight = elementWith + 'px'
				vm.navIconHeight = (elementWith * 0.3764) + 'px';
				vm.newsBaoClass.newbaoListHeight = (w * 0.2826) + 'px'; //新料快报列表高度
			};
		},
		created() { 
      this.newsType = 208;
			document.title = '酒店民宿'	
		},
		methods: {
				       
        //-评论=============================================================
        
      
      
    //点击评论按钮
    handleComment(){
      this.c("handleComment","点击显示评论按钮")
      
        //显示评论窗口
            this.commentVisible = true
           //清空数据
           let vm = this
           setTimeout(function(){
              vm.commentY = 'translateY(0)'  
           },50);   
           //子组件加载数据
      this.$refs.articleComments.loadComment(this.newsId)
    },
         
      
         //加载评论数据
         onLoadComment() {
          if(!this.commentFinished){
            this.getComment(this.newsId);
          }
        },
        //-评论 end ==========================================================
      
     
		iframeLoaded(){console.log('iframeLoaded');
			this.iframeHeight='100%';
			this.conentsLoading = false;
		},
    	//显示文章
    	displayArticle(id,type){ 
    	  console.log(123)
    	  
        //显示文章窗口
        let vm = this
        this.articleVisible = true
        setTimeout(function() {
          vm.articleY = 'translateY(0)'  
        }, 50);     
        this.newsId = id
        setTimeout(function() {
          //vm.articleY = 'none'  
          vm.articleSrc = vm.HOST + '/View/Article.aspx?id=' + vm.newsId
        }, 50)

        this.conentsLoading = true;
        window.location.hash = '/HotelList?type=' + type + "&id=" + id;
        setTimeout(function() {
          vm.conentsLoading = false;
        }, 8000);
         
    	},
    	  getData(cid){   
        if(moment().diff((moment(this.lastLoadTime))) <1000 && this.lastLoadTime !=0 ){    
          this.loading = false    
          console.log("太快了")
          return 
        }
        console.log("moment().diff((moment(this.lastLoadTime)))",moment().diff((moment(this.lastLoadTime))))
        //this.HOST = 'http://localhost:55214/Server'
        let vm  = this;       
        //Toast('正在加载...');//return;
        let data =this.listQuery;
        data.cid = cid;
		data.zid = this.newsZid; //村长甄选ID
		data.pageSize = 8
        data = qs.stringify(data);
        request.post(this.HOST+'/Action/NewsAction.aspx?action=getByCategory',data)
      .then(function (res) {
        vm.lastLoadTime = moment().format('YYYY-MM-DD HH:mm:ss')     
         vm.loading = false     
        if(res.data.state==1){ 
            
            console.log("state",res.data.state)
          for(var i =0;i<res.data.list.length;i++){
            try{
              vm.list.push(res.data.list[i]);
            }catch(e){
              
            }
          }  
          if(res.data.list.length<=0 || res.data.list.length< vm.listQuery.pageSize){                     
             if(vm.list.length>0){
                  vm.listGoneVisible = true
                }
            vm.finished = true;
          }else{ 
            vm.listQuery.pageIndex++;
          }
       } else {
          Toast(res.data.msg); 
        }
      })
      .catch(function (response) {
        vm.loading = false
        vm.lastLoadTime = moment().format('YYYY-MM-DD HH:mm:ss')
        console.log(response);
      });
        
        
        
      },
    
			onLoad() {
			  if(!this.finished){
            console.log('onLoad:',new Date());
            this.getData(this.newsType);         
        }
				/*
        	let data = 
        	[
        		{id:1,title:'去年柳州旅游成绩喜人，2018年还将这样做！',addTime:'2018-01-01 00:00:00',pic:''},
        		{id:2,title:'2018柳州旅游嘉年华，正式开启全域旅游美好生活！',addTime:'2018-01-01 00:00:00',pic:''},
        		{id:3,title:'打破传统农庄经营模式，七彩农场开建融水首个房车营地',addTime:'2018-01-01 00:00:00',pic:''},
        		{id:4,title:'大手笔：柳州文旅集团2700万投向融水这个村',addTime:'2018-01-01 00:00:00',pic:''},
        		{id:5,title:'今年再打造10个宜居示范村 吴炜：柳州必须多看多学',addTime:'2018-01-01 00:00:00',pic:''},
        		{id:6,title:'柳州“五一”假期揽金10亿元，乡村旅游魅力爆棚',addTime:'2018-01-01 00:00:00',pic:''},
        		{id:7,title:'惊艳广西！融水双龙沟野奢帐篷酒店即将建成，靓爆了！',addTime:'2018-01-01 00:00:00',pic:''},
        		{id:8,title:'柳州4个地方入选广西首批特色小镇培育名单，2000万元扶持',addTime:'2018-01-01 00:00:00',pic:''},
        		{id:9,title:'柳州文旅集团进驻融水，计划五年内投资20亿元开发融水旅游',addTime:'2018-01-01 00:00:00',pic:''},
        		{id:10,title:'柳州又有三个地方晋升“国家4A级景区”榜单！',addTime:'2018-01-01 00:00:00',pic:''},
        		{id:11,title:'程阳八寨恢复营业首场“侗耕·敬牛节”活动圆满完成',addTime:'2018-01-01 00:00:00',pic:''},
        	]
        	
			for(let i = 0; i < data.length; i++) {
        		this.list.push(data[i]);
        	}
	        this.loading = false;
        */
				
/*
				setTimeout(() => {
					for(let i = 0; i < 10; i++) {
						let obj = {
							title: '标题',
							id: this.list.length + 1
						};
						this.list.push(obj);
					}
					this.loading = false;

					if(this.list.length >= 40) {
						this.finished = true;
					}
				}, 500);*/
			},
			hideAllComponents() {
				this.$refs.slider.$emit('autoplayStop');
				this.$refs.slider.$emit('autoplayStart', 3000);
				this.newClass.activeHeight = '0';
				this.payClass.activeHeight = '0';
				this.serviceClass.activeHeight = '0';
				this.active = 10;
			},
			//鲜料
			displayNewComponents() {

				if(this.newClass.activeHeight == '0') {
					this.newComponentsShow = true;
					this.payClass.activeHeight = '0';
					this.serviceClass.activeHeight = '0';
					this.newClass.activeHeight = 'calc(100%  - ' + this.titleHeight + ' + 1px)';
					this.$refs.slider.$emit('autoplayStop');
					this.$refs.slider.$emit('autoplayStart', 99999999);
					this.$refs.slider.$emit('slideTo', 0);
					this.$refs.slider.basicdata.currentPage = 0;
					this.activeColor = "#222633";
					//this.$refs.slider.$emit('slideNext');
					//this.$refs.slider.$emit('autoplayStop');   
					this.active = 0;

				} else {
					this.$refs.slider.$emit('autoplayStop');
					this.$refs.slider.$emit('autoplayStart', 3000);
					this.newClass.activeHeight = '0';
					this.active = 10;
				}
			},

			//趣玩
			displayPayComponents() {
				if(this.payClass.activeHeight == '0') {
					this.newClass.activeHeight = '0';
					this.serviceClass.activeHeight = '0';
					this.payClass.activeHeight = 'calc(100%  - ' + this.titleHeight + ' + 1px)';
					this.$refs.slider.$emit('autoplayStop');
					this.$refs.slider.$emit('autoplayStart', 99999999);
					this.$refs.slider.$emit('slideTo', 0);
					this.$refs.slider.basicdata.currentPage = 0;
					this.activeColor = "#222633";
					this.active = 2;
				} else {

					this.$refs.slider.$emit('autoplayStop');
					this.$refs.slider.$emit('autoplayStart', 3000);
					this.payClass.activeHeight = '0';
					this.active = 10;
				}
			},

			   
          //关闭公共窗口
    closeAllCommon(){
      let type =parseInt(this.$route.query.type)
      let id =this.$route.query.id
       this.c("type",type)
     // 关闭评论窗口
      if(this.commentY == 'translateY(0)' || this.commentY == 'none' ){
       this.commentY = 'translateY(-100%)'
       this.c("commentY",this.commentY) 
       this.c("handleNavNew","关闭评论窗口")
       this.setTypeInfo(type,id,this.back)
        return true
     }
      //-从[村长甄选]入口
      if(type==1 || type==3 || type==4){
        this.$router.push({
          path: '/',
          query: {
            view: type
          }
       })
        return true
      }
     //关闭文章窗口
      if(this.articleY == 'translateY(0)'){
       this.c("handleNavNew","关闭文章窗口")
       this.c("articleY",this.articleY)
       this.c("type",type)
       this.articleY = 'translateY(-100%)'  
       this.setTypeInfo(type,'',this.back)
       return true
      } 
    },
			//导航栏跳转
    handleNavService(){
      
      let type =parseInt(this.$route.query.type)
      this.c("handleNavNew","点击[服务]导航栏")    
      //从别的地方跳转来,回到主菜单
     if(type != 208){      
       this.c("handleNavNew","回到[服务]主菜单")    
        this.$router.push({
            path: '/',
            query: {
              view: 1
            }
        });
        return
      }
       
      if(this.closeAllCommon()){
        return
      } 
      
      if(this.back=='search'){
          this.$router.push({
              path: '/',
              query: {
                view: 4
              }
           });
      }else if(type == 208 || type == 201 || type == 202 || type == 1001){
        this.$router.push({
              path: '/',
              query: {
                view: 4
              }
           });
      }
    },
   
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* 列表 */
 .list-gone{
  width: 100%;
  text-align: center;
  line-height: 55px;
  height: 55px;
  padding-bottom: 3%;
 }
  /* 列表  end*/
  
   /* 文章 */
 .article-components{
    position:relative;
    z-index: 3;
    height: calc(100% - 1.37rem);
    background-color: #FFFFFF;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling:touch;
    -webkit-transition: transform 400ms;
    transition: transform 400ms;
    transition-timing-function: ease;
    -webkit-transition-timing-function: ease;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
 }

 .btn-comments{
    position: fixed;
    top: 11.5%;
    width: 11%;
    right: 8.3%;
    z-index: 2;
 }
 /* 文章 end*/
 
 
 /* 评论 */

 .comments-total{
    position: fixed;
    top: 10%;
    right: 7%;
    z-index: 2;
    color: #fff;
    font-size: 15px;
    font-weight: normal;
    -webkit-transform: scale(0.8);
    transform: scale(0.8);
    text-align: center;
    box-sizing: border-box;
    padding: 0 6px;    
    min-width: 28px;
    line-height: 28px;
    border-radius: 16px;
    background-color: rgba(0, 145, 67, 0.8);
 }
 .comment-components{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    z-index: 4;
    height: calc(100% - 1.37rem);
    background-color: #FFFFFF;
    overflow: hidden;
    -webkit-overflow-scrolling:touch;
    -webkit-transition: transform 400ms;
    transition: transform 400ms;
    transition-timing-function: ease;
    -webkit-transition-timing-function: ease;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
 } 
 /* 评论 end*/
  
 
 
	
	.menu-components {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 3;
		width: 100%;
		height: 0;
		overflow: hidden;
		background-color: #FFF;
	}
	.eye{
		width: 15%;		
	}
</style>
<style>
	
.child-view {  
  position: absolute;  
  left: 0;  
  top: 0;  
  width: 100%;  
  height: 100%;  
  transition:none !important;   /*转场动画*/
}


</style>

<!-- 菜单 -->
<style scoped>
    .conents-loading{
  	position: absolute;
  	top:20%;
  	left:45%;
  	}
	.view-service-list-warp .new-list-wrap {
		margin-top: 30px;
		margin-bottom: 100px;
	}
	 
	
	.view-service-list-warp .new-list .van-col:nth-child(odd) {
		margin-bottom: 0 !important;
		padding-left: 17px !important;
		padding-right: 6px !important;
	}
	
	.view-service-list-warp .new-list .van-col:nth-child(even) {
		margin-bottom: 0 !important;
		padding-left: 6px !important;
		padding-right: 17px !important;
	}
	
	.view-service-list-warp .content-title{ 		
		font-size: 0.34rem;
		line-height: 0.38rem;
		height:  1.2rem;
		/*将height设置为line-height的整数倍，防止超出的文字露出*/
		color: #222633;
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 3;  
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
	}
	
	.newbao-list-wrap {
		position: relative;
		height:100%;
		overflow-y: auto;
		overflow-x: hidden;
		-webkit-overflow-scrolling:touch;
	}
</style>
<style>
	
	.view-service-list-warp .new-menu {
		margin-top: 10px;
	}
	
	.view-service-list-warp .new-menu img {
		height: 17px !important;
		/*16px*/
		width: auto;
		margin-bottom: 8px;
	}
	
	.view-service-list-warp .list-title {
		height: 17px !important;
		/*53%!important;*/
		margin-bottom: 10px!important;
		width: auto;
	}
	
	.view-service-list-warp .new-list-wrap .van-cell__value,
	.view-service-list-warp .new-menu .van-cell {
		font-size: 15px;
		font-weight: bold;
		padding: 6px 15px;
	}
	
	.view-service-list-warp .new-list-wrap .van-cell__value--alone {
		padding: 0;
	}
	
	.new-list-wrap .van-col:nth-child(even) {
		/*background-color: #66c6f2;*/
	}
	
	.view-service-list-warp .new-list-wrap .van-col {
		color: #fff;
		font-size: 13px;
		line-height: 30px;
		text-align: center;
		margin-bottom: 10px;
		background-clip: content-box;
	}
	
	.view-service-list-warp .new-list-wrap .van-col:nth-child(odd) {
		/*background-color: #39a9ed;*/
	}
	
	.view-service-list-warp .news-list-title .van-cell {
		padding-bottom: 0 !important;
	}
	/* 城事精选 */
	
	.view-service-list-warp .quancun-list-wrap {
		position: relative;
		height: calc(100% - 1.37rem);
		overflow-y: auto;
		overflow-x: hidden;
		
    -webkit-overflow-scrolling:touch;
	}
	.view-service-list-warp .quancun-list-wrap .van-cell {
		width: 3.65rem;
		height: calc(4.87rem + 0.15rem);	
		padding: 0;
		border-top: 0.18rem solid #e8e9eb;
		float: left;
	}
	.view-service-list-warp .quancun-list-wrap .van-cell:nth-of-type(odd){	
		width: calc(3.65rem + 0.2rem);	 
		border-right: 0.2rem solid #e8e9eb;
	}
	.view-service-list-warp .quancun-list-wrap .van-cell__value--alone {
		
		/*height: calc(2.75rem + 2.12rem);*/
		 
	}
	
	 
	.view-service-list-warp .quancun-list-img {
		position: relative;
		width: 100%;
		height: 2.75rem;
		right: 0;
		top: 0;
		background-color: #FFF;
		background-position: center;
		background-size: auto 100%;
	}
	
 
	.view-service-list-warp .newbao-list-content {
		position: relative;
		font-weight: bold;
		padding: 0.25rem 0.35rem;		
		height:  calc(2.12rem - 0.25rem - 0.25rem);
	}
	
	
	.view-service-list-warp .quancun-list-bottom {
		position: absolute;
		bottom: 0.27rem;
		width: calc(100% - 0.27rem );
		line-height: 0.26rem;
		font-size: 0.26rem;
		color: #8A8A8A;
	}
	
	.view-service-list-warp .quancun-list-bottom span:nth-child(1) {
		 
	}
	
	.view-service-list-warp .quancun-list-bottom span:nth-child(2) {
		position: absolute;		
		right: 0.41rem;
		top: 0;
		width: 38%;
		text-align: right;		
	}
	.view-service-list-warp .van-loading--white {
    padding: 10px;
    border-radius: 3px;
    background-color: rgba(0, 0, 0, .5);
    margin: auto;
    margin-top: 35%;
}
	/* 城事精选 end*/
</style>


// WEBPACK FOOTER //
// src/components/service/List.vue